import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const ForwardConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  forwardConfirmMessage,
  tableType,
}) => {
  const getMessage = () => {
    if (forwardConfirmMessage) return forwardConfirmMessage;
    const typeText =
      tableType === "orders"
        ? "siparişi"
        : tableType === "licenses"
        ? "lisansı"
        : "kaydı";
    return `Bu ${typeText} yönlendirmek istediğinizden emin misiniz?`;
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>İşlem Onayı</DialogTitle>
      <DialogContent>{getMessage()}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          İPTAL
        </Button>
        <Button onClick={onConfirm} color="primary">
          ONAYLA
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ForwardConfirmDialog;
